module.exports = __webpack_public_path__ + "img/cmbc.da466d85.jpg";